
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"61","height":"56","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#56BDD2","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M60.878 23.643a1.284 1.284 0 00-1.163-.733h-3.798C53.5 9.894 41.992 0 28.197 0 12.65 0 0 12.562 0 28c0 15.44 12.649 28 28.197 28 10.034 0 19.391-5.363 24.42-13.993a2.535 2.535 0 00-.937-3.478 2.568 2.568 0 00-3.5.928C44.063 46.52 36.406 50.91 28.197 50.91c-12.72 0-23.07-10.276-23.07-22.907 0-12.633 10.35-22.91 23.07-22.91 10.956 0 20.136 7.631 22.475 17.818h-3.769c-.5 0-.95.286-1.163.733-.211.448-.143.975.177 1.355l6.408 7.636a1.285 1.285 0 001.97 0L60.702 25c.32-.381.387-.909.175-1.356z"}}),_c('path',{attrs:{"d":"M28.452 7a2.54 2.54 0 00-2.544 2.536v15.388A4.427 4.427 0 0024 28.557c0 2.448 1.998 4.44 4.454 4.44a4.41 4.41 0 001.878-.43l8.851 5.091a2.545 2.545 0 003.476-.927 2.53 2.53 0 00-.933-3.463l-8.86-5.098A4.414 4.414 0 0031 24.926V9.536A2.545 2.545 0 0028.452 7zm0 23.458a1.907 1.907 0 01-1.908-1.9 1.908 1.908 0 013.816 0c0 1.046-.856 1.9-1.908 1.9z"}})])])
          )
        }
      }
    